const API_KEY = "b95212516123eb5e8fc973cbadc1bd71";

export default API_KEY;
